import React, { useRef, useCallback } from 'react';
import { Grid } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import CircleProgressButton from '../buttons/CircleProgressButton';
import AudioIcon from '@mui/icons-material/MusicNoteRounded';
import { validateAudioUpload } from '../pages/CreatePage/helpers';
import { AUDIO_UPLOAD_SUPPORTED_FORMATS } from '../pages/CreatePage/CreatePageConstants';
import ColoredSnackbarConstants from '../misc/ColoredSnackbar/ColoredSnackbarConstants';

const styles = theme => ({
    centerContainer: {
        padding: theme.spacing(4)
    }
});

const UploadAudioSection = React.memo(({
    classes,
    audioPreparing,
    savingInProgress,
    audioAnalyzing,
    audioSettings,
    isDefaultAudio,
    videoSettings,
    accountDetails,
    applyNewAudioFile,
    showMessage,
    isVideoExportsQueued,
    showCriticalOperationProgressWarning
}) => {
    const inputRef = useRef(null);

    const handleUploadClick = useCallback(() => {
        if (savingInProgress) {
            showCriticalOperationProgressWarning();
            return;
        }

        if (isVideoExportsQueued()) {
            return;
        }

        inputRef.current?.click();
    }, [savingInProgress, isVideoExportsQueued, showCriticalOperationProgressWarning]);

    const handleFileChange = useCallback((event) => {
        const file = event.target.files[0];
        if (!file) return;

        const { subscriptionType: userSubscriptionType } = accountDetails;

        validateAudioUpload(file, userSubscriptionType)
            .then(() => {
                applyNewAudioFile(videoSettings.id, file);
            })
            .catch((message) => {
                showMessage(message, ColoredSnackbarConstants.SNACKBAR_WARNING);
                event.target.value = '';
            });
    }, [accountDetails, videoSettings.id, applyNewAudioFile, showMessage]);

    return (
        <>
            <input
                type='file'
                accept={AUDIO_UPLOAD_SUPPORTED_FORMATS.join(",")}
                id='export-audio-input'
                onChange={handleFileChange}
                style={{ display: 'none' }}
                ref={inputRef}
            />
            <Grid 
                container
                justifyContent='center'
                className={classes.centerContainer}
            >
                <CircleProgressButton
                    variant='outlined'
                    color="inherit"
                    startIcon={<AudioIcon />}
                    onClick={handleUploadClick}
                    component='span'
                    disabled={audioPreparing || savingInProgress || audioAnalyzing}
                    loading={audioPreparing || (audioSettings.url && !isDefaultAudio)}
                >
                    Upload Audio
                </CircleProgressButton>
            </Grid>
        </>
    );
});

export default withStyles(UploadAudioSection, styles);